import { useTranslation } from "react-i18next"

function Modal({
    modalId = "modal_id",
    buttonClass = "btn-primary",
    buttonIcon = <i className="fa-solid fa-circle-check"></i>,
    buttonLabel,
    iconOnly = false, // Show only icon on the modal-open button
    isConfirm = false,
    title = null,
    body,
    locked = false,
    modalLocked = false,
    confirmStyle = null,
    onConfirm = () => { },
    onCancel = () => { }
}) {

    const [t] = useTranslation("global")
    let closeButtonId = `closeModalButton_${modalId}`

    const closeModal = () => { document.getElementById(closeButtonId).click() }

    function handleConfirm() {
        closeModal()
        onConfirm()
    }

    let _confirmStyle = confirmStyle || buttonClass || "btn-primary"

    let _confirm = isConfirm ? <><i className="fa-solid fa-circle-check"></i> {t("action.confirm")}</> : <>{buttonIcon} {buttonLabel}</>

    return (
        <>
            <button type="button" className={`btn ${buttonClass} ${modalLocked && "disabled"}`} data-bs-toggle="modal" data-bs-target={`#${modalId}`}>
                {buttonIcon} {!iconOnly && buttonLabel}
            </button>
            <div className="modal fade " id={`${modalId}`} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content bg-dark">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5" id="exampleModalLabel">{title ? title : t("helper.confirm_request")}</h1>
                            <button type="button" className="btn-close bg-light" id={closeButtonId} data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body bg-black bg-opacity-25 text-start">
                            {body}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={onCancel}> {t("action.cancel")}</button>
                            <button type="button" className={`btn ${_confirmStyle} ${locked && "disabled"}`} onClick={handleConfirm}>{_confirm}</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Modal